import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FiMenu, FiLogOut } from 'react-icons/fi';
import { useAuth } from '../../context/AuthContext';

const TeacherNav = ({ onToggleCollapse, isMobile }) => {
    const { user, logout } = useAuth();
    const navigate = useNavigate();
    const handleLogout = () => { logout(); navigate('/login'); };
    const initials = (user?.name || 'T').split(' ').map(n => n[0]).join('').toUpperCase().slice(0, 2);

    return (
        <header style={{
            height: isMobile ? 64 : 60, display: 'flex', alignItems: 'center', justifyContent: 'space-between',
            padding: isMobile ? '0 12px' : '0 24px', background: 'rgba(255,255,255,0.92)',
            backdropFilter: 'blur(16px)', borderBottom: '1px solid rgba(99,102,241,0.12)',
            boxShadow: '0 1px 12px rgba(99,102,241,0.07)', position: 'sticky', top: 0, zIndex: 100,
        }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: isMobile ? 8 : 12 }}>
                {!isMobile && (
                    <button onClick={onToggleCollapse} style={{ width: 36, height: 36, borderRadius: 10, border: 'none', background: 'rgba(99,102,241,0.08)', color: '#6366f1', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                        <FiMenu size={18} />
                    </button>
                )}
                {isMobile && (
                    <img src="/svu-logo.png" alt="SVU" style={{ width: 36, height: 36, objectFit: 'contain' }} />
                )}
                <h2 style={{ fontSize: isMobile ? 15 : 16, fontWeight: 800, color: '#1e1b4b', margin: 0, fontFamily: "'Outfit', sans-serif", letterSpacing: -0.3 }}>
                    Exam Panel
                </h2>
            </div>

            <div style={{ display: 'flex', alignItems: 'center', gap: isMobile ? 6 : 10 }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: 6, padding: '4px 12px 4px 4px', borderRadius: 50, background: 'rgba(99,102,241,0.04)', border: '1px solid rgba(99,102,241,0.1)' }}>
                    <div style={{ width: 28, height: 28, borderRadius: '50%', background: 'linear-gradient(135deg,#818cf8,#6366f1)', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#fff', fontSize: 11, fontWeight: 800 }}>
                        {initials}
                    </div>
                    {!isMobile && (
                        <div>
                            <div style={{ fontSize: 12, fontWeight: 700, color: '#1e1b4b', fontFamily: "'Outfit', sans-serif", lineHeight: 1 }}>{user?.name?.split(' ')[0] || 'Teacher'}</div>
                            <div style={{ fontSize: 9, color: '#6366f1', fontWeight: 700, fontFamily: "'Outfit', sans-serif", textTransform: 'uppercase', marginTop: 2 }}>Teacher</div>
                        </div>
                    )}
                </div>
                <button onClick={handleLogout} style={{ display: 'flex', alignItems: 'center', gap: isMobile ? 0 : 6, padding: isMobile ? '6px 8px' : '7px 14px', borderRadius: 10, border: '1px solid rgba(239,68,68,0.2)', background: 'rgba(239,68,68,0.06)', color: '#dc4f4f', cursor: 'pointer', fontSize: 13, fontWeight: 600, fontFamily: "'Outfit', sans-serif" }}>
                    <FiLogOut size={isMobile ? 16 : 14} /> {!isMobile && 'Logout'}
                </button>
            </div>
        </header>
    );
};

export default TeacherNav;
